import React from "react";
import Checkbox from "@mui/material/Checkbox";
import { Controller, Control, UseFormRegister } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface CheckBoxProps {
  control?: Control<any, any>;
  register?: any;
  name: string;
  required: boolean;
  isChecked?: () => boolean;
  onChange?: any;
  helpertext?: any;
}

const FmCheckBox = (props: CheckBoxProps) => {
  const { control, register, name, required, isChecked, onChange, helpertext } = props;
  const { t } = useTranslation();

  if (!control) {
    return (
      <Checkbox
        onChange={onChange}
        sx={{
          padding: 0,
          width: 22,
          height: 22,
          "& .MuiSvgIcon-root": {
            height: "25px",
            width: "25px",
            borderRadius: "2px",
            marginTop: "2px",
          },
          "&:not(.Mui-checked)": {
            "& svg": {
              backgroundColor: "#E6EAED",
              height: "22px",
              width: "22px",
              "& path": {
                fill: "#E6EAED",
              },
            },
          },
        }}
      />
    );
  }

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: {
          value: true,
          message: t("signUp.checkBoxError"),
        },
      }}
      render={({ field }) => {
        return (
          <Checkbox
            {...register(name, { required: required })}
            {...field}
            checked={isChecked ? isChecked() : undefined}
            helpertext={helpertext}
            sx={{
              padding: 0,
              width: 22,
              height: 22,
              "& .MuiSvgIcon-root": {
                height: "25px",
                width: "25px",
                borderRadius: "2px",
                marginTop: "2px",
              },
              "&:not(.Mui-checked)": {
                "& svg": {
                  backgroundColor: "#E6EAED",
                  height: "22px",
                  width: "22px",
                  "& path": {
                    fill: "#E6EAED",
                  },
                },
              },
            }}
          />
        );
      }}
    />
  );
};

export default FmCheckBox;
